import Vue from 'vue'
import Router from 'vue-router'
import AccessRecovery from '@/views/access-recovery/index.vue'

Vue.use(Router)

export const constantRoutes = [
  {
    path: '/access-unavailable',
    component: AccessRecovery,
    name: 'AccessRecovery',
    meta: { hidden: true }
  },
  {
    path: '/',
    component: () => import('../components/common/Home.vue'),
    redirect: '/home',
    name: 'AuthenticatedShell',
    meta: { title: '工作台', hidden: true },
    children: [
      {
        path: 'home',
        component: () => import('@/views/home/index.vue'),
        name: 'SafeHome',
        meta: { title: '工作台', hidden: true, keepAlive: false }
      },
      {
        path: 'setting',
        component: () => import('@/views/setting/index.vue'),
        name: 'Setting',
        meta: { title: '个人中心', hidden: true, keepAlive: false }
      }
    ]
  },
  {
    path: '/403',
    component: () => import('../components/page/403.vue'),
    name: '403',
    meta: { title: '403', permission: [1, 2, 3, 4, 5], hidden: true }
  },
  {
    path: '/404',
    component: () => import('../components/page/404.vue'),
    name: '404',
    meta: { title: '404', permission: [1, 2, 3, 4, 5], hidden: true }
  },
  {
    path: '/amazon/oauth/callback',
    component: () => import('@/views/amazon/oauth-callback/index.vue'),
    name: 'AmazonOAuthCallback',
    meta: { title: 'Amazon授权回调', hidden: true }
  },
  {
    name: 'Login',
    path: '/login',
    component: () => import('@/views/login/index.vue'),
    meta: { hidden: true }
  }
]

const createRouter = () => new Router({
  mode: 'history', // require service support
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter () {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router



// WEBPACK FOOTER //
// ./src/router/index.js